module.exports = __webpack_public_path__ + "img/icon-ana-voting.14ec19fb.png";